import { createContext, useContext } from 'react';

export const KeycloakContext = createContext<any>(undefined);
export const useKeycloakContext = () => useContext(KeycloakContext);
